import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  onlyShowMissedSLALastWorkingDay: boolean
  onlyShowMissedSLA2DaysInARow: boolean
  onlyShowMissedSLAAnyTime: boolean
}

export const DEFAULT_FILTER: Filter = {
  onlyShowMissedSLALastWorkingDay: false,
  onlyShowMissedSLA2DaysInARow: false,
  onlyShowMissedSLAAnyTime: false,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const SLAFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Just show missed SLA last working day"
      checked={filter.onlyShowMissedSLALastWorkingDay}
      onChange={e =>
        onChangeFilter({
          ...filter,
          onlyShowMissedSLALastWorkingDay: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Just show missed SLA 2 days in a row"
      checked={filter.onlyShowMissedSLA2DaysInARow}
      onChange={e =>
        onChangeFilter({
          ...filter,
          onlyShowMissedSLA2DaysInARow: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Just show missed SLA at any point"
      checked={filter.onlyShowMissedSLAAnyTime}
      onChange={e =>
        onChangeFilter({
          ...filter,
          onlyShowMissedSLAAnyTime: e.target.checked,
        })
      }
    />
  </>
)

export default SLAFilter
